import { FormHeader } from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS, SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>FormHeader,
  mapEntryToProps: (entry: SSO_MODELS.FormHeader & MEMBERSHIP_MODELS.FormHeader) =>
    kontentAiDataMapping.form_header(entry),
};
